export default __webpack_public_path__ + "static/media/logo.371552c6.png";